import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from '../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Orion from "./NoData_Orion";
import ChartLoader_Orion from "./ChartLoader_Orion";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import BucketTable_neteng_Orion from "./BucketTable_neteng_Orion";
import BucketTable_netkwh_Orion from "./BucketTable_netkwh_Orion";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";

export default function NetEnergyConsumption_Orion({ apiend, gloablfilter, title, type }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState("median_whPerKM");

  let modal_title = title;

  const appyData = (data) => {
    if (type === "netenergy")
      SetFieldName("median_whPerKM")
    const res_result = data;
    let res_result_final = []
    let responce = {
      "<0.25": 0,
      "0.5": 0,
      "0.75": 0,
      "1": 0,
      "1.25": 0,
      "1.5": 0,
      // "1.9": 0,
      // "2": 0,
      // ">2": 0,
      ">1.6": 0,
    };

    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map(d => {
        let value = parseFloat(d.median_whPerKM.values["50.0"]);
        if (isNaN(value))
          value = 0
        if ((d.median_whPerKM.values["50.0"] === null))
          d.median_whPerKM.values["50.0"] = 0.00000
        if (value < 0.25) {
          responce["<0.25"] = responce["<0.25"] + 1;
        } else if (value >= 0.25 && value < 0.5) {
          responce["0.5"] = responce["0.5"] + 1;
        } else if (value >= 0.5 && value < 0.75) {
          responce["0.75"] = responce["0.75"] + 1;
        } else if (value >= 0.75 && value < 1) {
          responce["1"] = responce["1"] + 1;
        } else if (value >= 1 && value < 1.25) {
          responce["1.25"] = responce["1.25"] + 1;
        } else if (value >= 1.25 && value < 1.5) {
          responce["1.5"] = responce["1.5"] + 1;
        }
        // else if (value >= 1.8 && value < 1.9) {
        //   responce["1.9"] = responce["1.9"] + 1;
        // }
        // else if (value >= 1.9 && value < 2) {
        //   responce["2"] = responce["2"] + 1;
        // }
        else if (value >= 1.6) {
          responce[">1.6"] = responce[">1.6"] + 1;
        }
      })
      res_result_final = [["Element", "Count", { role: "style" }]]
      let loop_keys = Object.keys(responce);
      // loop_keys = ["<1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2", ">2"]
      loop_keys = ["<0.25", "0.5", "0.75", "1", "1.25", "1.5", ">1.6"]
      loop_keys.map(x => {
        // res_result_final.push([x, responce[x], "#83A4CF"]);
        res_result_final.push([x, responce[x], "stroke-width: 1;stroke-color: black;"]);
      })

      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
    }
  }

  const options = {
    hAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'kWh/km',
      minValue: 0,
      format: 'short',
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Vehicle Count',
      minValue: 0,
      format: 'short',
    },
    bar: { groupWidth: "100%" },
    legend: "none", isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "orion_drive_api/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter, apiend])

  return (
    <>
      <div className="chartHGT">
        <WaterMark />
        {(isLoading) ? <ChartLoader_Orion /> : ((chartdata.length == 0) ? <NoData_Orion /> : <Chart chartType="ColumnChart" width="100%" height="210px" data={chartdata} options={options} chartEvents={[
          {
            eventName: 'select',
            callback: ({ chartWrapper }) => {
              const chart = chartWrapper.getChart()
              const selection = chart.getSelection()
              if (selection.length === 1) {
                const [selectedItem] = selection;
                const { row } = selectedItem;

                // const barvalue = parseInt((chartWrapper.getDataTable().Wf[row].c[0].v));
                const barvalue = chartWrapper.getDataTable().Wf[row].c[0].v;
                const count = chartWrapper.getDataTable().Wf[row].c[1].v;
                if (count != 0) {
                  let filtered_temp = [];
                  if (fieldname === "median_whPerKM") {
                    filtered_temp = apiresponce.filter(x => {

                      if (x.median_whPerKM.values["50.0"] < barvalue && x.median_whPerKM.values["50.0"] >= barvalue - 0.1) {
                        return x;
                      }
                      // else if (x.median_whPerKM.values["50.0"] >= 2 && barvalue === ">2") {
                      else if (x.median_whPerKM.values["50.0"] >= 1.8 && barvalue === ">1.8") {
                        return x
                      }
                      else if (x.median_whPerKM.values["50.0"] < 1.3 && barvalue === "<1.3") {
                        return x
                      }
                    })
                  }

                  function compareObjects(object1, object2, key) {
                    let obj1 = []
                    let obj2 = []
                    if (fieldname === "median_whPerKM") {
                      obj1 = object1.median_whPerKM.values["50.0"]
                      obj2 = object2.median_whPerKM.values["50.0"]
                    }
                    else if (fieldname === "median_NetkWh") {
                      obj1 = object1.median_NetkWh.values["50.0"]
                      obj2 = object2.median_NetkWh.values["50.0"]
                    }
                    if (obj1 > obj2) {
                      return -1
                    }
                    if (obj1 < obj2) {
                      return 1
                    }
                    return 0
                  }

                  filtered_temp.sort((value1, value2) => {
                    return compareObjects(value1, value2, 'vehicalId')
                  })
                  SetfilteredData(prestate => filtered_temp);
                  window.$('#exampleModal__' + apiend).modal('show');
                }
              }
            }
          }
        ]}
        />)}

        <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">{"kWh/km"}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              {/* <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}> */}
              <div className="modal-body">
                {/* <table className="table table-striped">
                  <thead style={{ backgroundColor: '#83A4CF', color: '#fff' }}>
                    <tr>
                      <th scope="col">Vin Number</th>
                      <th scope="col">value</th>
                    </tr></thead>
                  <tbody> */}
                <BucketTable_neteng_Orion data={filteredData} />
                {/* </tbody></table> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

}
